import { v4 as uuidv4 } from 'uuid';

export type MediaUploadState = 'uploaded' | 'uploading' | 'error';

export type Media = {
  id: string;
  state: MediaUploadState;
  progress: number;
  serverId: string;
  errorMessage: string;
  lastUpdated: number;
  url: string | null;
};

export const createMedia = (
  data: Pick<Media, 'state' | 'url'> & Partial<Media>,
): Media => {
  const { id, url, serverId, progress, state, lastUpdated, errorMessage } =
    data;
  return {
    id: id ?? uuidv4(),
    lastUpdated: lastUpdated ?? Date.now(),
    errorMessage: errorMessage ?? '',
    state,
    url,
    serverId: serverId ?? '',
    progress: progress ?? state === 'uploaded' ? 100 : 0,
  };
};

export const getUploadedMedia = (mediaItems: Media[]) => {
  return mediaItems.filter((media) => !!media.serverId);
};
